module.exports = __webpack_public_path__ + "static/media/hero-van-category.700e3ec4.png";